import { useEffect, useState } from 'react'
import { Form, Select } from 'antd'
import { SDrawerOrModal } from 'shj-components'
import styles from './index.module.less'

const SubMaterialModal = ({
  open = false,
  subNumber = 0,
  onClose = () => ({}),
  subMaterialInfo = {},
}: any) => {
  const [form] = Form.useForm()

  return (
    <SDrawerOrModal
      open={open}
      mode='modal'
      title="减项价明细"
      okText="保存"
      cancelText="取消"
      onCancel={() => {
        onClose()
      }}
      antdProps={{
        footer: null
      }}
    >
      <div className={styles.subMaterialBox}>
        <p
          className={styles.productNameBox}
        >
          {subMaterialInfo.name}
        </p>
        <div className={styles.infoBox}>
          <div>
            类型：{ subMaterialInfo?.deductionPriceDetail?.sourceDtlIsStandard ? '标配' : '增项' || '-'}
          </div>
          <div>
            &nbsp;|&nbsp;数量：{ subNumber }
          </div>
        </div>
        {
          (subMaterialInfo?.deductionPriceDetail?.subType === 'actualPayment' && !subMaterialInfo?.deductionPriceDetail?.sourceDtlIsStandard) ? (
            <>
              <div className={styles.priceBox}>
                <div className={styles.title} style={{ marginTop: '5px' }}>
                  资金池：<span className={styles.price}>{ (subMaterialInfo?.deductionPriceDetail?.releaseCapitalAmount || subMaterialInfo?.deductionPriceDetail?.releaseCapitalAmount === 0) ? '￥' + String(subMaterialInfo?.deductionPriceDetail?.releaseCapitalAmount) : '-' }</span>
                </div>
                <div style={{ marginTop: '5px' }}>
                  计算公式: { subMaterialInfo?.deductionPriceDetail?.releaseCapitalAmountFormular || '-' }
                </div>
                <div style={{ marginTop: '5px' }}>
                  退款金额: { subMaterialInfo?.deductionPriceDetail?.releaseCapitalAmountResolvedFormular || '-' }
                </div>
              </div>
              <div className={styles.priceBox}>
                <div className={styles.title} style={{ marginTop: '5px' }}>
                  增配实际支付金额：<span className={styles.price}>{ (subMaterialInfo?.deductionPriceDetail?.addActualAmount || subMaterialInfo?.deductionPriceDetail?.addActualAmount === 0) ? '￥' + String(subMaterialInfo?.deductionPriceDetail?.addActualAmount) : '-' }</span>
                </div>
                <div style={{ marginTop: '5px' }}>
                  计算公式: { subMaterialInfo?.deductionPriceDetail?.addActualAmountFormular || '-' }
                </div>
                <div style={{ marginTop: '5px' }}>
                  退款金额: { subMaterialInfo?.deductionPriceDetail?.addActualAmountResolvedFormular || '-' }
                </div>
              </div>
              <div className={styles.priceBox}>
                <div className={styles.title} style={{ marginTop: '5px' }}>
                  实付款：<span className={styles.price}>{ (subMaterialInfo?.deductionPriceDetail?.actualAmount || subMaterialInfo?.deductionPriceDetail?.actualAmount === 0) ? '￥' + String(subMaterialInfo?.deductionPriceDetail?.actualAmount) : '-' }</span>
                </div>
              </div>
            </>
          ) : null
        }
        {
          (subMaterialInfo?.deductionPriceDetail?.subType === 'actualPayment' && subMaterialInfo?.deductionPriceDetail?.sourceDtlIsStandard) ? (
            <>
              <div className={styles.priceBox}>
                <div className={styles.title} style={{ marginTop: '5px' }}>
                  实付款：<span className={styles.price}>{ (subMaterialInfo?.deductionPriceDetail?.actualAmount || subMaterialInfo?.deductionPriceDetail?.actualAmount === 0) ? '￥' + String(subMaterialInfo?.deductionPriceDetail?.actualAmount) : '-' }</span>
                </div>
                <div style={{ marginTop: '5px' }}>
                  计算公式: { subMaterialInfo?.deductionPriceDetail?.actualAmountFormular || '-' }
                </div>
                <div style={{ marginTop: '5px' }}>
                  退款金额: { subMaterialInfo?.deductionPriceDetail?.actualAmountResolvedFormular || '-' }
                </div>
              </div>
            </>
          ) : null
        }
        {
          (subMaterialInfo?.deductionPriceDetail?.subType === 'returnDiscount') ? (
            <>
              <div className={styles.priceBox}>
                <div className={styles.title} style={{ marginTop: '5px' }}>
                  折扣退款：<span className={styles.price}>{ (subMaterialInfo?.deductionPriceDetail?.actualAmount || subMaterialInfo?.deductionPriceDetail?.actualAmount === 0) ? '￥' + String(subMaterialInfo?.deductionPriceDetail?.actualAmount) : '-' }</span>
                </div>
                <div style={{ marginTop: '5px' }}>
                  计算公式: { subMaterialInfo?.deductionPriceDetail?.actualAmountFormular || '-' }
                </div>
                <div style={{ marginTop: '5px' }}>
                  退款金额: { subMaterialInfo?.deductionPriceDetail?.actualAmountResolvedFormular || '-' }
                </div>
              </div>
            </>
          ) : null
        }
      </div>
    </SDrawerOrModal>
  )
}

export default SubMaterialModal
